module.exports = __webpack_public_path__ + "img/map-image.7c5de75b.png";